<!-- 临时接单平台 -->
<template>
    <div class="temporary">
        <!-- 标题内容 -->
        <div class="topbox">
            <el-row type="flex" justify="space-between" align="middle">
                <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                    <p class="title">楚天惠家保增值服务预约</p>
                    <!-- <i class="el-icon-user-solid" :style="{ color: isConnected ? '#61c455' : '#6c6e74' }"></i> -->
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" style="margin-top:20px">
                    <el-row type="flex" justify="space-between" align="middle" class="title-box">
                        <el-col :span="4">
                            <p class="titledata">接单量</p>
                            <p class="titlevalue">{{ titleDate.receivNum }}</p>
                        </el-col>

                        <el-col :span="4">
                            <span class="titledata">已完成</span>
                            <p class="titlevalue">{{ titleDate.completeNum }}</p>
                        </el-col>

                        <el-col :span="4">
                            <span class="titledata">待完成</span>
                            <p class="titlevalue">{{ titleDate.assignNum }}</p>
                        </el-col>

                        <el-col :span="4">
                            <span class="titledata">待指派</span>
                            <p class="titlevalue"> {{ titleDate.waitNum }} </p>
                        </el-col>

                        <el-col :span="4">
                            <span class="titledata">退单量</span>
                            <p class="titlevalue">{{ titleDate.refundNum }}</p>
                        </el-col>
                    </el-row>

                    <!-- <el-row>
                        <el-col>
                            <div style="margin-top: 15px;">
                                <el-input placeholder="请输入内容" v-model="findVal">
                                    <el-select v-model="select" slot="prepend" placeholder="请选择">
                                    <el-option label="手机号" value="1"></el-option>
                                    <el-option label="订单号" value="2"></el-option>
                                    <el-option label="地址" value="3"></el-option>
                                    </el-select>
                                    <el-button slot="append" icon="el-icon-search"></el-button>
                                </el-input>
                                </div>
                        </el-col>
                    </el-row> -->

                </el-col>

            </el-row>
        </div>


        <!-- 表格数据处理 -->
        <div class="tablebox">
            <el-row justify="space-between">
                <!-- 操作烂 -->
                <el-col>
                    <div class="optionbox">
                        <div class="tabsbox">
                            <el-tabs v-model="activeName" @tab-click="handleClick" class="custom-tabs">
                                <el-tab-pane label="全部" name="all"></el-tab-pane>
                                <el-tab-pane label="已完成" name="completed"></el-tab-pane>
                                <el-tab-pane label="待完成" name="incomplete"></el-tab-pane>
                                <el-tab-pane label="待派单" name="dispatch"></el-tab-pane>
                                <el-tab-pane label="已退单" name="chargeback"></el-tab-pane>
                            </el-tabs>
                        </div>

                        <div class="optionbtn">
                            <!-- 搜索-->
                            <el-button icon="el-icon-search" circle size="small" @click="searchData"></el-button>
                            <!-- 刷新-->
                            <el-button icon="el-icon-refresh" circle size="small" @click="refreshData"></el-button>
                            <!-- 导出表格 -->
                            <el-button icon="el-icon-upload2" circle size="small" disabled></el-button>

                        </div>
                    </div>
                </el-col>

                <!-- 数据内容 -->
                <el-col class="tablecol">
                    <el-table :data="tableData" id="tables" stripe style="width: 100%" height="600" size="small">
                        <!-- 详细信息 -->
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" size="small" inline class="demo-table-expand">
                                    <el-form-item label="联系人:">
                                        <span>{{ props.row.contacts }}</span>
                                    </el-form-item>
                                    <el-form-item label="联系电话:">
                                        <span>{{ props.row.contacts_tel }}</span>
                                    </el-form-item>
                                    <el-form-item label="订单号:">
                                        <span>{{ props.row.order_id }}</span>
                                    </el-form-item>
                                    <el-form-item label="保单号:">
                                        <span>{{ props.row.policy_no }}</span>
                                    </el-form-item>
                                    <el-form-item label="服务区域:">
                                        <span>{{ props.row.region }}</span>
                                    </el-form-item>
                                    <el-form-item label="服务地址:">
                                        <span>{{ props.row.address }}</span>
                                    </el-form-item>
                                    <el-form-item label="服务内容:">
                                        <span>{{ props.row.service_type_name }}</span>
                                    </el-form-item>
                                    <el-form-item label="预约时间:">
                                        <span>{{ props.row.mail_time }}</span>
                                    </el-form-item>
                                    <el-form-item label="提交时间:">
                                        <span>{{ props.row.create_time }}</span>
                                    </el-form-item>

                                    <el-form-item label="供应商:">
                                        <span>{{ props.row.give_service_name }}</span>
                                        <el-button size="mini" round icon="el-icon-edit-outline"
                                            @click="updateService(props.row)"
                                            v-if="props.row.state !== 2 && props.row.state !== -1" />
                                    </el-form-item>

                                    <el-form-item label="其他操作:">
                                        <el-button size="small" type="danger" plain @click="chargeback(props.row)"
                                            v-if="props.row.state !== 2 && props.row.state !== -1">退单</el-button>

                                        <el-button size="small" type="success" plain @click="complete(props.row)"
                                            v-if="props.row.state == 1">完成订单</el-button>
                                    </el-form-item>

                                    <el-form-item label="描述备注:">
                                        <span>{{ props.row.desc }}</span>
                                        <el-button size="mini" round icon="el-icon-edit-outline"
                                            @click="updateDesc(props.row)" />
                                    </el-form-item>

                                </el-form>
                            </template>
                        </el-table-column>
                        <!-- 表格信息 -->
                        <el-table-column label="序号" width="50">
                            <template v-slot:default="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column label="订单 ID" prop="order_id" width="150" />
                        <el-table-column label="联系人" prop="contacts" width="100" />
                        <el-table-column label="联系电话" prop="contacts_tel" width="120" />
                        <el-table-column label="服务区域" prop="region" />
                        <el-table-column label="服务地址" prop="address" />
                        <el-table-column label="服务项目" prop="service_type_name" />
                        <el-table-column label="服务商" prop="give_service_name" width="120" />
                        <el-table-column label="来源" width="80">
                            <template v-slot:default="scope">
                                <el-tag v-if="scope.row.channel == '0'" size="mini">微保</el-tag>
                                <el-tag v-else type="danger" size="mini">其他</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="预约时间" prop="create_time" width="120" />

                        <el-table-column label="复制" width="50">
                            <template v-slot:default="scope">
                                <el-button icon="el-icon-document-copy" circle size="mini"
                                    @click="copyData(scope)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>

                <!-- 分页 -->
                <!-- <el-col class="paginationcol">
                    <el-pagination background layout="prev, pager, next" :total="1000">
                    </el-pagination>
                </el-col> -->
            </el-row>
        </div>


        <!-- 修改供应商弹窗 -->
        <el-dialog :visible.sync="dialogFormService" title="选择供应商">
            <!-- 供应商选择 -->
            <el-select v-model="give_service_id" placeholder="请选择服务商">
                <el-option v-for="item in giveServiceList" :key="item.giveServiceId" :label="item.giveServiceName"
                    :value="item.giveServiceId">
                </el-option>
            </el-select>



            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="cancellation">取消</el-button>
                    <el-button type="primary" @click="setServiceRadio" :disabled="give_service_id == ''">确认</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 修改备注信息 -->
        <el-dialog :visible.sync="dialogFormDesc" title="修改描述内容" width="800">
            <!-- 备注信息 box -->
            <el-input type="textarea" :rows="8" placeholder="请输入描述或备注" v-model="descVal"></el-input>

            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogFormDesc = false">取消</el-button>
                    <el-button type="primary" @click="setServiceDesc" :disabled="descVal == ''">确认</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 搜索数据对话框 -->
        <el-dialog title="订单查询" :visible.sync="isSearchDialog">
            <el-form :model="searchForm">

                <el-form-item label="搜索条件" label-width="120px">
                    <el-radio-group v-model="searchForm.condition">
                        <el-radio label="订单号"></el-radio>
                        <el-radio label="手机号"></el-radio>
                        <el-radio label="保单号"></el-radio>
                        <el-radio label="预约姓名"></el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="搜索内容" label-width="120px">
                    <el-input v-model="searchForm.searchVal"></el-input>
                </el-form-item>

                <el-collapse v-model="collapseIndex" accordion>
                    <el-collapse-item :title="`${item.contacts}-${item.contacts_tel}-${item.service_type_name}`"
                        :name="index" v-for='(item, index) in searchList' :key="index">
                        <!-- <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div> -->
                        <!-- <li>订单号：{{item.order_id}}</li>
                         <li>联系人：{{item.contacts}}</li>
                         <li>联系电话：{{item.contacts_tel}}</li>
                         <li>服务区域：{{item.region}}</li>
                         <li>服务地址：{{item.address}}</li>
                         <li>服务内容：{{item.service_type_name}}</li>
                         <li>供应商：{{item.give_service_name}}</li>
                         <li>保单号：{{item.policy_no}}</li>
                         <li>预约时间：{{item.create_time}}</li> -->

                        <el-descriptions title="订单信息">
                            <el-descriptions-item label="订单号">{{ item.order_id }}</el-descriptions-item>
                            <el-descriptions-item label="联系人">{{ item.contacts }}</el-descriptions-item>
                            <el-descriptions-item label="联系电话">{{ item.contacts_tel }}</el-descriptions-item>
                            <el-descriptions-item label="服务区域">{{ item.address }}</el-descriptions-item>
                            <el-descriptions-item label="服务内容">{{ item.service_type_name }}</el-descriptions-item>
                            <el-descriptions-item label="供应商">{{ item.give_service_name }}</el-descriptions-item>
                            <el-descriptions-item label="保单号">{{ item.policy_no }}</el-descriptions-item>
                            <el-descriptions-item label="预约时间">{{ item.create_time }}</el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>
                </el-collapse>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="searchClick(false)">取 消</el-button>
                <el-button type="primary" @click="searchClick(true)"
                    :disabled="searchForm.condition == '' || searchForm.searchVal == ''">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

// descriptions
import { Tag, Descriptions, DescriptionsItem, Collapse, CollapseItem, Button, Row, Col, Divider, Form, FormItem, Input, Select, Option, Avatar, Tabs, TabPane, Table, TableColumn, Dialog, RadioGroup, Radio } from 'element-ui';

import { PostMsg } from '../constant.js'
// import SockJS from 'sockjs-client';
// import { Client } from '@stomp/stompjs';
// 创建一个 Audio 对象
const audio = new Audio(require('@/assets/提示.mp3'));

export default {
    components: {
        ElDescriptions: Descriptions,
        EldDescriptionsItem: DescriptionsItem,
        ElCollapse: Collapse,
        ElCollapseItem: CollapseItem,
        ElButton: Button,
        ElRow: Row,
        ElCol: Col,
        ElDivider: Divider,
        ElForm: Form,
        ElFormItem: FormItem,
        ElInput: Input,
        ElSelect: Select,
        ElOption: Option,
        ElAvatar: Avatar,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        ElTable: Table,
        ElTableColumn: TableColumn,
        ElDialog: Dialog,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElTag: Tag
    },
    data() {
        return {
            //
            findVal: '', // 搜索内容
            isSearchDialog: false, // 搜索窗口
            //订单搜索表单内容
            searchForm: {
                condition: [],// 搜索条件
                searchVal: '',// 搜索内容
            },
            collapseIndex: 0,
            searchList: [], // 搜索数据

            lastOrderId: '', // 最后一个数据 ID
            titleDate: {},// 标题数据内容
            activeName: 'dispatch',// 快速选择
            tableLonad: true, // 表格加载状态

            // 表格数据
            tableData: [], // 表格数据
            giveServiceList: [], // 服务商清单

            // 供应商弹窗
            dialogFormService: false, // 供应商修改弹窗
            optionDialogItem: {},// 正在操作的对象
            give_service_id: '',// 选择的服务商 id

            // 描述备注弹窗
            dialogFormDesc: false, // 弹窗开关
            descDialogItem: {}, // 选择的对象
            descVal: '', // 内容

            // 加载状态
            loadingInstance: null,  // 用来保存 loading 实例

            // websocket 
            isConnected: false,// 连接状态
            stompClient: null, // 连接对象
            isRefresh: false,// 是否刷新，解决并发

        };
    },
    mounted() {

        this.refreshData() // 初始化数据
        // this.connectWebSocket()// 创建 websocket 连接
        // audio.muted=true
    },
    methods: {
        // 复制信息
        copyData(scope) {
            // console.log(scope.row);
            const item=scope.row

            const copy=`${item.order_id}\n${item.contacts}\n${item.contacts_tel}\n${item.region}\n${item.address}\n${item.service_type_name}\n`
            try {
                navigator.clipboard.writeText(copy);
                this.$message.success('复制成功');
            } catch (err) {
               this.$message.error('复制失败');
            }

        },
        // 搜索按钮
        searchClick(isFlash) {

            if (!isFlash) {
                this.isSearchDialog = false
                return
            }

            let { condition, searchVal } = this.searchForm


            switch (condition) {
                case '订单号':
                    condition = 'ORDER_ID'
                    break;
                case '手机号':
                    condition = 'ORDER_TEL'
                    break;
                case '保单号':
                    condition = 'ORDER_POLICY'
                    break;
                case '预约姓名':
                    condition = 'ORDER_NAME'
                    break;

            }

            const parent = new FormData()
            parent.append('condition', condition) // 订单号
            parent.append('searchVal', searchVal) // 

            // 模糊搜索内容
            PostMsg('/temporaryMsg/searchOrderDim', parent).then(res => {
                console.log('模糊搜索：', res);
                if (res.data.state == 200) {
                    this.searchList = res.data.data
                }
            })
        },
        // 搜索订单
        searchData() {
            this.isSearchDialog = true
        },
        // 创建 websocket 链接
        // connectWebSocket() {
        //     const socket = new SockJS(WEBSOCKET_WX); // WebSocket 服务端地址
        //     this.stompClient = new Client({
        //         webSocketFactory: () => socket,
        //         reconnectDelay: 0, // 禁用自动重连
        //         heartbeatIncoming: 5000, // 客户端每 4 秒发送一次心跳
        //         heartbeatOutgoing: 5000, // 服务器每 4 秒发送一次心跳

        //         onConnect: (frame) => {
        //             console.log('websocket连接成功:', frame);


        //             // 连接成功后订阅 /topic/updateData，监听后台推送的消息
        //             this.stompClient.subscribe('/topic/updateData', (message) => {

        //                 if (!this.isRefresh) {

        //                     this.isRefresh = true
        //                     this.$notify({
        //                         title: '提醒',
        //                         message: '来新订单啦！',
        //                         type: 'success'
        //                     })

        //                     audio.play().catch((error) => {
        //                         console.error('播放音频失败:', error);
        //                     });  // 播放声音
        //                     console.log('来新订单啦！', message);
        //                     this.isRefresh = false
        //                 }
        //             });

        //             this.isConnected = true;
        //         },

        //         // 连接断开
        //         onDisconnect: (frame) => {
        //             console.log("WebSocket 连接断开", frame);
        //             this.isConnected = false; // 更新连接状态
        //         },
        //         // STOMP 协议错误
        //         onStompError: (frame) => {
        //             console.error("STOMP 协议错误", frame);
        //             this.isConnected = false;
        //         },
        //         // WebSocket 连接错误
        //         onWebSocketError: (error) => {
        //             console.error("WebSocket 错误", error);
        //             this.isConnected = false;
        //         },
        //         onclose: (event) => {
        //             console.log('WebSocket 连接已关闭', event);
        //             this.isConnected = false;
        //         },

        //         onerror: (error) => {
        //             console.error('WebSocket 错误:', error);
        //             this.isConnected = false;
        //         }
        //     });

        //     this.stompClient.activate();  // 激活连接
        // },
        // 刷新数据内容
        refreshData() {
            // 开启加载页面
            const loadingInstance = this.$loading({
                target: document.getElementById('tables')
            })

            this.getFindTitleDate();// 获取标题数据
            this.getTypeServiceList();// 获取服务商清单
            // this.getLastOrderId();
            this.handleClick(this.activeName); // 获取数据内容

            // 关闭加载
            loadingInstance.close()
        },
        // 获取最后一个数据的 ID
        getLastOrderId() {
            PostMsg('/temporaryMsg/findLastDate').then(res => {
                console.log('获取最后一笔数据 ID：', res);
                if (res.data.state == 200) {
                    this.lastOrderId = res.data.data
                }
            })
        },
        // 获取标题数据内容
        getFindTitleDate() {
            PostMsg('/temporaryMsg/findTitleDate').then(res => {
                console.log('获取标题数据内容：', res);
                if (res.data.state == 200) {
                    this.titleDate = res.data.data

                }
            })


        },
        // 完成订单操作
        complete(item) {
            this.$confirm('完成订单是否继续?', '提示', {
                confirmButtonText: '确认完成',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log('完成订单');

                const parent = new FormData()
                parent.append('orderId', item.order_id) // 订单号
                parent.append('policyNo', item.policy_no) // 

                PostMsg('/temporaryMsg/compleleOrder', parent).then(res => {
                    console.log('订单完成操作：', res);
                    if (res.data.state == 200) {
                        this.$message({
                            message: '推送成功',
                            type: 'success'
                        });
                        // this.handleClick(this.activeName); // 重新获取表格信息
                        this.refreshData() // 初始化数据

                    } else {
                        this.$message.error('推送失败');
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '出错'
                });
            });
        },

        // 退单操作
        chargeback(item) {
            this.$confirm('此操作将订单删除是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const parent = new FormData()
                parent.append('orderId', item.order_id) // 订单号
                parent.append('policyNo', item.policy_no) // 订单号

                PostMsg('/temporaryMsg/cancellationOrder', parent).then(res => {
                    console.log('推送服务商：', res);
                    if (res.data.state == 200) {
                        this.dialogFormDesc = false;
                        this.$message({
                            message: '推送成功',
                            type: 'success'
                        });

                        // this.handleClick(this.activeName); // 重新获取表格信息
                        this.refreshData() // 初始化数据

                    } else {
                        this.$message.error('推送失败');
                    }
                })

            }).catch(() => {

            });

        },
        // 修改备注内容
        setServiceDesc() {
            // 后台请求修改数据
            const parent = new FormData()
            parent.append('desc', this.descVal) // 需要推送的服务商
            parent.append('orderId', this.descDialogItem.order_id) // 订单号

            // 跳转到
            PostMsg('/temporaryMsg/descriptionChange', parent).then(res => {
                console.log('推送服务商：', res);
                if (res.data.state == 200) {
                    this.dialogFormDesc = false;
                    this.$message({
                        message: '推送成功',
                        type: 'success'
                    });

                    // this.handleClick(this.activeName); // 重新获取表格信息
                    this.refreshData() // 初始化数据

                } else {
                    this.$message.error('推送失败');
                }
            })
        },
        // 开启描述弹窗
        updateDesc(item) {
            this.descVal = item.desc
            this.descDialogItem = item
            this.dialogFormDesc = true
        },
        // 修改服务商 弹窗
        updateService(item) {
            this.give_service_id = item.give_service_id
            this.optionDialogItem = item
            this.dialogFormService = true // 弹窗开关
        },
        // 取消弹窗
        cancellation() {
            // 修改供应商弹窗
            this.dialogFormService = false // 供应商修改弹窗
            this.optionDialogItem = {}// 正在操作的对象
            this.give_service_id = ''// 选择的服务商 id

            this.dialogFormDesc = false
            this.descDialogItem = {}
        },
        // 修改服务商
        setServiceRadio() {
            // 后台请求修改数据
            const parent = new FormData()
            parent.append('giveServiceId', this.give_service_id) // 需要推送的服务商
            parent.append('orderId', this.optionDialogItem.order_id) // 订单号
            parent.append('policyNo', this.optionDialogItem.policy_no) // 订单号


            // 跳转到
            PostMsg('/temporaryMsg/appointService', parent).then(res => {
                console.log('推送服务商：', res);
                if (res.data.state == 200) {
                    this.dialogFormService = false;
                    this.$message({
                        message: '推送成功',
                        type: 'success'
                    });

                    // this.handleClick(this.activeName); // 重新获取表格信息
                    this.refreshData() // 初始化数据

                } else {
                    this.$message.error('推送失败');
                }
            })
        },
        // 获取服务商清单
        getTypeServiceList() {
            PostMsg('/temporaryMsg/servicelist').then(res => {
                console.log('获取服务商配置：', res);

                if (res.data.state == 200) {
                    this.giveServiceList = res.data.data
                } else {
                    this.$message.error('获取服务商名单错误...');
                }

            })
        },
        // 获取订单清单
        getOrderList(type) {

            this.tableData = []
            const parent = new FormData()
            parent.append('menuType', type)

            // 跳转到
            PostMsg('/temporaryMsg/orderList', parent).then(res => {
                console.log('获取订单详情：', res);
                if (res.data.state == 200) {
                    this.tableData = res.data.data
                } else {
                    // console.log('异常');
                    this.$message.error('程序错误了...');
                }
            })
        },
        handleClick(activeName) {
            // this.$refs.audio.play();
            let active = typeof activeName == 'string' ? activeName : activeName.name
            console.log('activeNamexxxx:', active);

            let type = '0'; // 0=全部，1=待派单，2=已退单的

            switch (active) {
                case ' all': // 全部
                    type = '0';
                    break;
                case 'dispatch': // 待派单
                    type = '1';
                    break;
                case 'chargeback': // 已退单
                    type = '2';
                    break;
                case 'completed': // 已完成
                    type = '3';
                    break;
                case 'incomplete': // 未完成
                    type = '4';
                    break;

            }

            this.getOrderList(type) // 获取订单信息
        }
    },
    // 销毁关闭 socket
    beforeDestroy() {
        if (this.stompClient) {
            this.stompClient.deactivate();  // 页面销毁时断开连接
        }
    },
};
</script>

<style lang="less" scoped>
/* 使用 /deep/ 选择器进行样式穿透 */
.el-tabs /deep/ .el-tabs__nav-wrap::after {
    display: none !important;
    content: none !important;
    height: 0px !important;
    background-color: white !important;
}

.el-tabs /deep/ .el-tabs__header,
.el-tabs /deep/ .el-tabs__nav {
    border-bottom: none !important;
}

.temporary {
    width: 100vw;
    height: 100vh;
    text-align: center;

    .title {
        font-size: 25px;
        font-weight: bold;
        float: left;
    }

    .title-box {
        width: 100%;

        .titledata {
            font-size: 15px;
            color: #828282;
        }

        .titlevalue {
            font-size: 25px;
            color: #2e2e2e;
            font-weight: bold;
        }

    }

    .topbox {
        margin: 20px;
    }

    .tablebox {
        min-height: 300px;
        margin: 20px;
        background-color: white;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        overflow: hidden;




        .optionbox {
            margin: 10px;
            // border: 1px solid red;
            border-bottom: 1px solid rgb(227, 227, 227);
            display: flex;
            justify-content: space-between;
            align-items: center;

        }

        .tablecol {

            .demo-table-expand {
                // padding: 10px;
                // border: 1px solid red;
                // font-size: 0;
                font-size: 14px;
                margin: 20px;
                padding: 20px;
                background-color: #ffffff;
                border-radius: 10px;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            }

            .el-icon {
                // border: 1px solid red;
                margin-left: 20px;
            }

            .demo-table-expand .el-form-item {
                margin-right: 0;
                margin-bottom: 0;
                width: 50%;

            }
        }

        // .paginationcol {
        //     border: 1px solid red;
        // }
    }
}
</style>